<div class="content-text" fxLayout="column">
  <ng-container *ngIf="!isNotClientDetailsPage">
    <p class="message-text accent-text-color">{{ addressChangeText }}</p>
  </ng-container>

  <ng-container *ngIf="!showAddressForm">
    <app-google-autocomplete
      (setAddress)="addressSelected($event)"
      (manualEntry)="showAddressForm = true"
      [countryCode]="countryCode"
    >
    </app-google-autocomplete>
  </ng-container>

  <div *ngIf="showAddressForm">
    <form [formGroup]="addressForm" fxLayout="column">
      <ng-container *ngFor="let field of addressFields">
        <!-- Text Input Field -->
        <mat-form-field *ngIf="field.type === 'text'" appearance="outline">
          <mat-label>{{ field.label }}</mat-label>
          <input
            [formControlName]="field.key"
            [required]="isFieldRequired(field.key)"
            matInput
          />
          <ng-container
            *ngFor="let validation of getFieldValidationMessages(field.key)"
          >
            <mat-error
              *ngIf="hasFieldError(field.key, validation.type)"
              class="error-message"
            >
              {{ validation.message }}
            </mat-error>
          </ng-container>
        </mat-form-field>

        <!-- Select Dropdown Field -->
        <mat-form-field *ngIf="field.type === 'select'" appearance="outline">
          <mat-label>{{ field.label }}</mat-label>
          <mat-select
            [formControlName]="field.key"
            [required]="isFieldRequired(field.key)"
          >
            <mat-option
              *ngFor="let option of field.options"
              [value]="option.value"
            >
              {{ option.label }}
            </mat-option>
          </mat-select>
          <ng-container
            *ngFor="let validation of getFieldValidationMessages(field.key)"
          >
            <mat-error
              *ngIf="hasFieldError(field.key, validation.type)"
              class="error-message"
            >
              {{ validation.message }}
            </mat-error>
          </ng-container>
        </mat-form-field>

        <!-- Textarea Field -->
        <mat-form-field *ngIf="field.type === 'textarea'" appearance="outline">
          <mat-label>{{ field.label }}</mat-label>
          <textarea
            [formControlName]="field.key"
            [required]="isFieldRequired(field.key)"
            matInput
            rows="3"
          >
          </textarea>
          <ng-container
            *ngFor="let validation of getFieldValidationMessages(field.key)"
          >
            <mat-error
              *ngIf="hasFieldError(field.key, validation.type)"
              class="error-message"
            >
              {{ validation.message }}
            </mat-error>
          </ng-container>
        </mat-form-field>
      </ng-container>

      <div
        fxLayout="row"
        fxLayoutAlign="end center"
        fxLayoutGap="10px"
        class="form-actions"
      >
        <button
          (click)="cancelUpdate()"
          color="warn"
          mat-stroked-button
          type="button"
        >
          Cancel
        </button>
        <button
          (click)="saveAddress()"
          [disabled]="addressForm.invalid"
          color="primary"
          mat-raised-button
          type="button"
        >
          Save
        </button>
      </div>
    </form>
  </div>
</div>
